import { __assign } from "tslib";
import * as React from 'react';
import { FocusOn as ReactFocusOn } from './UI';
import SideCar from './sidecar';
var RequireSideCar = function (props) {
    return React.createElement(SideCar, __assign({}, props));
};
export var FocusOn = React.forwardRef(function (props, ref) { return React.createElement(ReactFocusOn, __assign({}, props, { ref: ref, sideCar: RequireSideCar })); });



//////////////////
// WEBPACK FOOTER
// ./~/react-focus-on/dist/es2015/Combination.js
// module id = 9000
// module chunks = 2